import { render, staticRenderFns } from "./AgentTransferInfo.vue?vue&type=template&id=79da8baa&"
import script from "./AgentTransferInfo.vue?vue&type=script&lang=js&"
export * from "./AgentTransferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports